var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TinyMce',{attrs:{"id":_vm.id,"api-key":'qwtvgxcwmati501oy9zae1rp0kqrubq1704bmhi325lte2gw',"init":_vm.config,"disabled":_vm.disabled,"name":"textarea"},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }